function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Heading } from '../../atoms';
import { LightArrowRight } from '../../visuals';
import ReactConfigContext from '../../ReactConfigContext';
export default function SearchResultRow(param) {
    var title = param.title, description = param.description, action = param.action, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge('mb-7 pb-7 border-b border-b-fg-base/25', 'last-of-type:border-b-0 last-of-type:mb-9', className)
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge('flex items-center justify-between', action.className)
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4",
        className: "text-link-fg-base mb-3"
    }, title), /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "prose"
    }, description)), /*#__PURE__*/ React.createElement("span", {
        className: "ml-6 hidden md:ml-9 md:block"
    }, /*#__PURE__*/ React.createElement(LightArrowRight, null))));
}

//# sourceMappingURL=SearchResultRow.js.map